/* ============================================================
   PULLORAX - FIT THE PRODUCT TO ITS FRAME (21 Sept 2026)

   Owner, on a phone: "the pictures are small". The frames were already made
   bigger; what stayed small was the PRODUCT inside each photograph. Catalogue
   photos are squares with the box somewhere in the middle and white all
   round it - one deck set fills a third of its square, a booster pack fills
   nine tenths of its own. A single zoom for all of them either leaves the
   small ones tiny or cuts the tall ones. So each photograph is measured.

   HOW. Once an image has loaded it is drawn onto an 80px canvas and scanned
   for the pixels that are not near-white; their bounding box is the product.
   The top-right corner is skipped while scanning - that is where the PulloraX
   watermark sits, and counting it would stretch the box to the corner. The
   image is then scaled and moved so the product fills 86% of its frame,
   centred. Nothing is cropped off the product: the box that is fitted IS the
   product.

   ONLY INSIDE A CLIPPING FRAME. The zoom is applied only when the image's own
   frame clips (overflow hidden/clip); anywhere else it is removed. That keeps
   the hero's cut-out act and the desktop hero exactly as they were, and means
   a stale stylesheet can never let a zoomed photo spill out of its card.

   PHYSICAL SIZE (owner's rule: no image shown larger than its real pixels).
   The zoom is capped so the product is never drawn with more device pixels
   than the loaded file has.

   CORRECTION, same night, found on the real site on an iPhone-sized screen:
   the cap read img.naturalWidth, and for an image chosen from a srcset the
   browser reports naturalWidth divided by the chosen density - i.e. roughly
   the CSS width, not the file's pixels. So an 800px file on a 3x phone read
   as ~250px, the cap came out below 1 and almost nothing was zoomed. The real
   pixel width is now read from a plain copy of the same URL (a cache hit).
   And when the file loaded is too small for the zoom the product needs, a
   larger one is asked for: a srcset image gets a larger `sizes` so the browser
   picks a bigger candidate; a plain Shopify image URL (the hero's photo acts)
   gets a larger width= once the bigger file has finished loading, so the
   swap is never a blank frame. A file that is simply small stays capped.

   SAFE BY DEFAULT. Images normally come from the shop's own domain (/cdn/shop),
   so the canvas can read them. If a browser refuses (a cross-origin file), one
   CORS copy of the same URL is fetched to measure; if that fails too, or the
   photo has a coloured background (the box is then the whole photo), the image
   is left exactly as it was.

   PERFORMANCE (1 Oct 2026, owner approved). The zoom used to be applied one
   image at a time: measure an image, write its transform, measure the next -
   every measurement after a write forced the browser to recalculate the whole
   page's style and layout again (about 66 images on the home page). Images are
   now queued and handled together once per frame: ALL measurements first,
   then ALL transforms written. The result on screen is identical; only the
   number of forced recalculations drops to one per frame. A transform that
   is already in place is not written again.

   Applies to: product plates (.px-plate), the coverflow cards (.pd__cf-med),
   Buy-with-clarity photos (.pd__confidence-img) and the hero's photo acts on a
   phone (.pd__stage a.pd__box). The hero swaps one image's src on every act;
   each new load is measured again.
   ============================================================ */
(function(){
  if(window.__pxFit) return;
  window.__pxFit=true;
  var SEL='.px-plate img, .pd__cf-med img, .pd__confidence-img img, .pd__stage a.pd__box > img';
  var FILL=0.86, MAXS=3, MAXW=2400;
  var REAL={}, UP={};

  /* bounding box of the non-white pixels, as fractions of the image; throws
     if the canvas is not allowed to read the pixels */
  function measure(src){
    var w=src.naturalWidth, h=src.naturalHeight;
    if(!w||!h) return null;
    var N=80;
    var cw=w>=h?N:Math.max(8,Math.round(N*w/h));
    var ch=h>=w?N:Math.max(8,Math.round(N*h/w));
    var c=document.createElement('canvas');
    c.width=cw; c.height=ch;
    var x=c.getContext('2d',{willReadFrequently:true});
    x.drawImage(src,0,0,cw,ch);
    var d=x.getImageData(0,0,cw,ch).data;
    var x0=cw, y0=ch, x1=-1, y1=-1;
    for(var yy=0; yy<ch; yy++){
      for(var xx=0; xx<cw; xx++){
        if(xx>cw*0.64 && yy<ch*0.18) continue; /* the watermark corner */
        var i=(yy*cw+xx)*4;
        if(d[i+3]<24) continue;
        if(d[i]>236 && d[i+1]>236 && d[i+2]>236) continue;
        if(xx<x0) x0=xx;
        if(xx>x1) x1=xx;
        if(yy<y0) y0=yy;
        if(yy>y1) y1=yy;
      }
    }
    return x1>=0 ? {x0:x0/cw, y0:y0/ch, x1:(x1+1)/cw, y1:(y1+1)/ch} : null;
  }

  function probe(img){
    if(img.__pxProbe) return;
    img.__pxProbe=true;
    var p=new Image();
    p.crossOrigin='anonymous';
    p.onload=function(){
      try{ img.__pxBox=measure(p); }catch(e){ img.__pxBox=null; }
      apply(img);
    };
    p.src=img.currentSrc||img.src;
  }

  function box(img){
    if(img.__pxBox!==undefined) return img.__pxBox;
    try{ img.__pxBox=measure(img); }
    catch(e){ img.__pxBox=null; probe(img); }
    return img.__pxBox;
  }

  /* the loaded file's real pixel width (0 = not known yet; apply() runs again
     when it is) */
  function real(img){
    var u=img.currentSrc||img.src;
    if(REAL[u]) return REAL[u];
    if(!img.getAttribute('srcset')){ REAL[u]=img.naturalWidth; return REAL[u]; }
    if(REAL[u]===0) return 0;
    REAL[u]=0;
    var q=new Image();
    q.onload=function(){ REAL[u]=q.naturalWidth||1; apply(img); };
    q.src=u;
    return 0;
  }

  /* ask for a file with at least `need` pixels across */
  function upgrade(img, need){
    var u=img.currentSrc||img.src;
    if(img.getAttribute('srcset')){
      if(img.__pxSizes) return;
      img.__pxSizes=true;
      img.sizes=Math.ceil(need/(window.devicePixelRatio||1))+'px';
      return;
    }
    var m=u.match(/[?&]width=(\d+)/);
    if(!m) return;
    var cur=+m[1];
    if(REAL[u] && REAL[u]<cur) return; /* the file is smaller than asked for: nothing larger exists */
    var w=Math.min(MAXW, Math.ceil(need/100)*100);
    if(w<=cur) return;
    if(UP[u]){
      if(UP[u].ready && (img.currentSrc||img.src)===u) img.src=UP[u].url;
      return;
    }
    var nu=u.replace(/([?&]width=)\d+/, '$1'+w);
    UP[u]={url:nu, ready:false};
    var q=new Image();
    q.onload=function(){
      UP[u].ready=true;
      REAL[nu]=q.naturalWidth;
      if((img.currentSrc||img.src)===u) img.src=nu;
    };
    q.src=nu;
  }

  function clips(el){
    if(!el) return false;
    var cs=window.getComputedStyle(el);
    var o=(cs.overflow||'')+' '+(cs.overflowX||'')+' '+(cs.overflowY||'');
    return o.indexOf('hidden')>-1 || o.indexOf('clip')>-1;
  }

  /* MEASURE ONLY - no style is written here. Returns the transform the image
     should carry: '' for none, a string for a zoom, or undefined to leave the
     image exactly as it is (not measurable yet). */
  function compute(img){
    /* 10 Oct 2026: a photo already centred and enlarged by the cut-out script
       (snippets/pullorax-hero-cut.liquid, data-px-cut) is left alone - both
       moving it doubled the shift (Storm Emeralda on the origin shelf sat at
       the top of its plate). */
    if(img.getAttribute('data-px-cut')) return '';
    if(!clips(img.parentElement)) return '';
    var b=box(img);
    if(!b) return '';
    var ew=img.clientWidth, eh=img.clientHeight;
    if(!ew||!eh) return undefined;
    var px=real(img);
    if(!px) return undefined;
    /* where the picture actually sits inside the element under object-fit:contain */
    var na=img.naturalWidth/img.naturalHeight, ea=ew/eh, cw=1, ch=1, ox=0, oy=0;
    if(window.getComputedStyle(img).objectFit==='contain'){
      if(na>ea){ ch=ea/na; oy=(1-ch)/2; } else { cw=na/ea; ox=(1-cw)/2; }
    }
    var fx0=ox+b.x0*cw, fx1=ox+b.x1*cw, fy0=oy+b.y0*ch, fy1=oy+b.y1*ch;
    var want=Math.min(FILL/(fx1-fx0), FILL/(fy1-fy0), MAXS);
    var dpr=window.devicePixelRatio||1;
    var cap=px/(ew*cw*dpr);
    if(want>cap*1.03) upgrade(img, Math.ceil(ew*cw*dpr*want));
    var s=Math.min(want, Math.max(1,cap));
    if(s<1.04) return '';
    var tx=s*(0.5-(fx0+fx1)/2)*100, ty=s*(0.5-(fy0+fy1)/2)*100;
    return 'translate('+tx.toFixed(2)+'%,'+ty.toFixed(2)+'%) scale('+s.toFixed(3)+')';
  }

  /* QUEUE: every request is collected and handled once per frame - all
     measurements first, then all writes. */
  var Q=[], qOn=false;
  function flush(){
    qOn=false;
    var list=Q, out=[], i;
    Q=[];
    for(i=0;i<list.length;i++){
      var v=compute(list[i]);
      if(v!==undefined) out.push([list[i],v]);
    }
    for(i=0;i<out.length;i++){
      var img=out[i][0], t=out[i][1];
      if(t){
        if(img.style.transformOrigin!=='50% 50%') img.style.transformOrigin='50% 50%';
        if(img.style.transform!==t) img.style.transform=t;
      } else if(img.style.transform){
        img.style.transform='';
      }
    }
  }
  function apply(img){
    if(Q.indexOf(img)<0) Q.push(img);
    if(qOn) return;
    qOn=true;
    requestAnimationFrame(flush);
  }

  function hook(img){
    if(img.__pxHook) return;
    img.__pxHook=true;
    if(img.complete && img.naturalWidth) apply(img);
    img.addEventListener('load',function(){ img.__pxBox=undefined; img.__pxProbe=false; apply(img); });
  }
  function run(){ [].forEach.call(document.querySelectorAll(SEL),hook); }

  var t=0;
  window.addEventListener('resize',function(){
    clearTimeout(t);
    t=setTimeout(function(){ [].forEach.call(document.querySelectorAll(SEL),apply); },150);
  });
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',run); } else { run(); }
  window.addEventListener('load',run);
})();
